export const PROJECTDATA = {
    LED_CUBE_8X8X8: {
        id: 0,
        date: "2013",
        title: "LED Cube 8x8x8",
        description: "This project I made while at school, I built and coded it all by myself using" +
            " PIC Microcontroller and wrote impressive 3D animations in C programing language" +
            ", the cube cube allowed me to control 512 LED's using only 72 outputs due to it's geometric design",
        img1: "/images/LedCube_img1.jpg",
        img2: "/images/LedCube_img2.jpg",
        img3: "/images/LedCube_img3.jpg",
        img4: "/images/LedCube_img4.jpg",
    },
    CAPACITOR_TEST_BED: {
        id: 2,
        date: "2015/2017",
        title: "HV Capacitors Lab",
        description: "Test bench used for aeging HV capacitors for assessing quality, dielectric integrety and strength," +
            "3 HV Converters creating deep discharge cicles with specific wave forms" +
            " in order to simulate harsh operating conditions, Temperature was also used as a stress factor." +
            " results were used to select the best technology and brands to use on Main Converters that supplied LHC magnets",
        img1: "/images/TestBed_img1.jpg",
        img2: "/images/TestBed_img2.jpg",
        img3: "/images/TestBed_img3.jpg",
        img4: "/images/TestBed_img4.jpg",
    },
    NI_DAQ_LABVIEW: {
        id: 3,
        date: " 2016",
        title: "Remote Control Panel",
        description: "Panel programed in Labview for remote control and survalliance, this project was built using NI modular DAQ's" +
            "and Labview to plot dozens of diferent analog signals and record events",
        img1: "/images/LabView_img1.jpg",
        img2: "/images/LabView_img2.jpg",
        img3: "/images/LabView_img3.jpg",
        img4: "/images/LabView_img4.jpg",
    },
    STEP_MOTOR_INTERFACE: {
        id: 4,
        date: "2016",
        title: "Step Motor Interface",
        description: "Step motor controled by PWM signal used to turn a 3-phase varic under heavy EMF noise enviroment, " +
            "project was completly done by me from design to instalattion, using various noise reduction and filtering techniques like Mu-Metal shielding" +
            " and common mode filters as well as in-board optocouplers to perform well under any condition",
        img1: "/images/StepMotor_img1.jpg",
        img2: "/images/StepMotor_img2.jpg",
        img3: "/images/StepMotor_img3.jpg",
        img4: "/images/StepMotor_img4.jpg",
    },
    SOLAR_SYSTEM: {
        id: 7,
        title: "Smart Motor Home",
        date: "2019",
        description: "I turned an old Motor Home into a 6KW power house using deep cycle AGM bateries supplied by policristalin solar panels" +
            " though a MPPT solar controler and finally delivered with a pure sine wave 1500W inverter." +
            " everything was routed to a Raspberry Pi that displayed all the stats on a GUI using a touch screen, this GUI" +
            " also alowed the control of some appliances inside the Motor Home, the GUI was made using Phyton.",
        img1: "/images/MotorHome_img1.jpg",
        img2: "/images/MotorHome_img2.jpg",
        img3: "/images/MotorHome_img3.jpg",
        img4: "/images/MotorHome_img4.jpg",
    },
    VAPOKISS: {
        id: 9,
        date: "2022",
        title: "E-Commerce store",
        description: " E-commerce store built using Next.js, Sanity headless CMS, Eupago Payment processing system, Firestore and Discord Webhooks. This website was moved into Woocomerce for ease of use and maintenance. ",
        img1: "/images/vapokiss_img1.png",
        img2: "/images/vapokiss_img2.png",
        img3: "/images/vapokiss_img3.png",
        img4: "/images/vapokiss_img4.png",
        github: "https://github.com/angomes94/Vapokiss"
    },
    TEAM_FLOW: {
        id: 10,
        date: "2023",
        title: "Project Management WebApp",
        description: " This is a CRUD app that I built using NEXT.js, Firebase Auth and Firestore" +
            " It allows business to organize projects, cordinate their teams and oversee everything that is happening" +
            " it's a fully functioning and scalable project.",
        img1: "/images/teamflow_img1.png",
        img2: "/images/teamflow_img2.png",
        img3: "/images/teamflow_img3.png",
        img4: "/images/teamflow_img4.png",
        github: "https://github.com/angomes94/teamflow",
        url: "https://teamflow-angomes94.vercel.app/"

    },
    SANCILIX: {
        id: 11,
        date: "2023",
        title: "Real Estate Construction Company",
        description: " Website built for a client using NEXT.js and Sanity headless CMS, The purpose of" +
        " the website is to give an introduction to the company and the team but also showcase the projects that have been built.",
        img1: "/images/sancilix_img1.png",
        img2: "/images/sancilix_img2.png",
        img3: "/images/sancilix_img3.png",
        img4: "/images/sancilix_img4.png",
        github: "https://github.com/angomes94/sancilix",
        url: "https://sancilix.vercel.app/"
    }
};





